import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import InlineSingleSelect from "../ui/form/InlineSingleSelect.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DeviceTypeSelector',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const deviceTypeProxy = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        const options = [
            {
                displayName: "Mobile View",
                value: "MOBILE",
                icon: "fal fa-mobile",
            },
            {
                displayName: "Desktop View",
                value: "DESKTOP",
                icon: "fal fa-desktop",
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(InlineSingleSelect, {
                size: 'small',
                options: options,
                modelValue: deviceTypeProxy.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((deviceTypeProxy).value = $event))
            }, null, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
